export default __webpack_public_path__ + "static/insight-66ed6a8197b7eb5c55bb78326a7113d6.png";